// extracted by mini-css-extract-plugin
export default {"background":"gallery_background__TBXtk","headers":"gallery_headers__uk3ky","boxs":"gallery_boxs__Aj14j","border":"gallery_border__m4HI5"};